<script lang="ts">
  import Dashboard from "@distributor/svelte/Storefront/Containers/Dashboard.svelte";
  import Splash from "@distributor/svelte/Storefront/Components/Splash.svelte";
  import Spinner from "@shared/svelte/Components/Spinner.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";

  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";

  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  import type { Storefront } from "@shared/types/Storefront";

  $: shouldShowSplash = !$CurrentUserStore?.has_seen_first_storefront_edit_modal;

  let storefront: Storefront;

  const fetchStorefronts = async (): Promise<Storefront[]> => {
    const res = await HttpPromise({
      method: "GET",
      url: "/api/distributor/storefronts",
    });
    storefront = res[0];
    return res;
  };

  const onClickGetStarted = () => {
    window.location.href = "/distributor/storefronts/" + storefront.distributor_id;
  };
</script>

{#await fetchStorefronts()}
  <Spinner />
{:then storefronts}
  <FizzStyles>
    <div class="fizz-layout-storefronts" style="margin-top: 60px;">
      {#if shouldShowSplash}
        <Splash {onClickGetStarted}></Splash>
      {:else}
        <Dashboard {storefronts}></Dashboard>
      {/if}
    </div>
  </FizzStyles>
{/await}
